import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=27077bd6&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=27077bd6&scoped=true&lang=css&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=27077bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27077bd6",
  null
  
)

export default component.exports